import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.GnZZHN',
    defaultMessage: 'Webhook',
  },
  error: {
    id: 'studio.Z3qPg/',
    defaultMessage: 'There was a problem loading the webhook secrets.',
  },
  loading: {
    id: 'studio.NkjT/r',
    defaultMessage: 'Loading webhook secrets …',
  },
  placeholder: {
    id: 'studio.AgUG6b',
    defaultMessage: 'example.com',
  },
  noSecrets: {
    id: 'studio.UWXUQt',
    defaultMessage: 'No webhook secrets have been configured yet.',
  },
  addNew: {
    id: 'studio.v9WChN',
    defaultMessage: 'Add new secret',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
});
